import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { CopilotOnboardingService } from '@pure1/data';
import { Router } from '@angular/router';
import { ampli } from 'core/src/ampli';
import { OnboardingModalComponent } from '../onboarding-modal/onboarding-modal.component';
import { CopilotSidePanelService } from '../services/copilot-side-panel.service';

@Component({
    templateUrl: './copilot-onboarding-modal.component.html',
    selector: 'copilot-onboarding-modal-internal',
    preserveWhitespaces: false,
    imports: [OnboardingModalComponent],
})
export class CopilotOnboardingModalComponent implements AfterViewInit {
    @ViewChild('copilotOnboardingModal') copilotOnboardingModal: OnboardingModalComponent;

    copilotUILibraryEnabled = false;

    constructor(
        private readonly copilotOnboardingService: CopilotOnboardingService,
        private readonly copilotSidePanelService: CopilotSidePanelService,
        private readonly router: Router,
    ) {}

    ngAfterViewInit(): void {
        this.copilotOnboardingService.modalVisible$.subscribe(modalVisible => {
            if (modalVisible) {
                this.copilotOnboardingModal?.copilotOnboardingModalDialog.show();
            } else {
                this.copilotOnboardingModal?.copilotOnboardingModalDialog.hide();
            }
        });
    }

    protected dismissModalDialog(): void {
        // `hive-content-dialog` emits its close event for a programmatic `hide()` as well as for
        // a user dismissal, so acking — which hides the modal — re-enters here. The modal is
        // hidden before that event arrives, so a close while it is still meant to be visible is
        // the only one the user asked for; anything else would undo the ack.
        if (!this.copilotOnboardingService.modalVisible$.value) {
            return;
        }

        ampli.copilotOnboardingModalButtonClicked({ onboardingButtonClicked: 'maybe later' });
        this.copilotOnboardingService.hideOnboardingModal();

        if (this.copilotOnboardingService.modalTrigger === 'side panel') {
            // Raised by an attempt to open the side panel, so declining leaves the user on the
            // page they were reading, with neither the panel nor the request it carried going
            // ahead (CLOUD-257763).
            this.copilotSidePanelService.onboardingDeclined();
            return;
        }

        // Raised by the full-page Copilot route, which has nothing to show a user who declined.
        this.router.navigate(['/']);
    }

    protected ackOnboardingModal(): void {
        ampli.copilotOnboardingModalButtonClicked({ onboardingButtonClicked: 'try now' });
        this.copilotOnboardingService.ackOnboardingModal();

        // Opting in lifts the side panel's onboarding hold either way. Where the panel is what
        // raised the modal, that also performs the open it was holding — including the prompt the
        // user clicked — so they get Copilot without leaving the page.
        const raisedBySidePanel = this.copilotOnboardingService.modalTrigger === 'side panel';
        this.copilotSidePanelService.onboardingAccepted();
        if (!raisedBySidePanel) {
            this.router.navigate(['/copilot']);
        }
    }
}
